import { useSelector } from 'react-redux'
import { RootState } from '@/store/store'

export function useAuthState() {
  return useSelector((state: RootState) => state.auth)
}
